export const UNLIMITED_SLOTS_FOR_CLUBPASS_MEMBERS = 999999999;
export const UNLIMITED_CODE_WORD = "Unlimited";
